import type { SpinnerProps } from "./Spinner.types";

type SpinnerSize = NonNullable<SpinnerProps["size"]>;
type SpinnerThickness = NonNullable<SpinnerProps["thickness"]>;
type SpinnerIntent = NonNullable<SpinnerProps["intent"]>;

export const sizeClasses: Record<SpinnerSize, string> = {
  sm: "h-4 w-4",
  md: "h-6 w-6",
  lg: "h-8 w-8",
};

export const dotSizeClasses: Record<SpinnerSize, string> = {
  sm: "h-1.5 w-1.5",
  md: "h-2 w-2",
  lg: "h-2.5 w-2.5",
};

export const pulseSizeClasses: Record<SpinnerSize, string> = {
  sm: "h-6 w-6",
  md: "h-8 w-8",
  lg: "h-10 w-10",
};

export const ringStrokeClasses: Record<SpinnerThickness, Record<SpinnerSize, string>> = {
  regular: {
    sm: "border",
    md: "border-2",
    lg: "border-2",
  },
  bold: {
    sm: "border-2",
    md: "border-[3px]",
    lg: "border-4",
  },
};

export const gradientPaddingClasses: Record<SpinnerThickness, Record<SpinnerSize, string>> = {
  regular: {
    sm: "p-[1px]",
    md: "p-[1.6px]",
    lg: "p-[2px]",
  },
  bold: {
    sm: "p-[1.8px]",
    md: "p-[2.8px]",
    lg: "p-[3.6px]",
  },
};

export const intentClasses: Record<SpinnerIntent, string> = {
  primary: "border-purple/25 border-t-purple",
  muted: "border-dark-invirtus/20 border-t-dark-invirtus/60",
  light: "border-light/35 border-t-light",
};

export function getDotToneClass(intent: SpinnerIntent): string {
  if (intent === "light") return "bg-light";
  if (intent === "muted") return "bg-dark-invirtus/60";
  return "bg-purple";
}

export function getHalfRingArcColorClass(intent: SpinnerIntent): string {
  if (intent === "light") return "border-light";
  if (intent === "muted") return "border-dark-invirtus/60";
  return "border-purple";
}

